import { Bar } from 'vue-chartjs'
import { mapState } from 'vuex'

import convertNumber from '@/services/mixins/convertNumber'

export default {
	extends: Bar,
	props: {
		data: Object
	},
	mixins: [
		convertNumber
	],
	data () {
		return {
			color: '41,103,205',
			gradient: null
		}
	},
	computed: {
        ...mapState(['user'])
	},
	watch: {
		data: function () {
			this.$data._chart.destroy()
			this.render()
		}
	},
	mounted () {
		this.render()
	},
	methods: {
		render () {

			this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0,0,0,450)
			this.gradient.addColorStop(0.0, `rgba(${this.color}, 1.0)`)
			this.gradient.addColorStop(0.4, `rgba(${this.color}, 0.4)`)
			this.gradient.addColorStop(1.0, `rgba(${this.color}, 0.0)`)

			this.renderChart(
				{
					labels: this.data.labels,
					datasets: [
						{
							backgroundColor: this.gradient,
							data: this.data.amounts
						}
					]
				},
				{
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						display: false
					},
					scales: {
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									callback: (value) => {
										return this.convertNumber(value, this.userTeam.settings.currency)
									}
								}
							}
						],
						xAxes: [
							{
								maxBarThickness: 12,
								ticks: {
									autoSkip: false,
									maxRotation: 45,
									minRotation: 45
								}
							}
						]
					},
					tooltips: {
						enabled: true,
						callbacks: {
							label: (tooltipItems => {
								return this.convertNumber(tooltipItems.yLabel, this.userTeam.settings.currency)
							})
						}
					}
				}
			)

		}
	}
}
